import * as i0 from "@angular/core";
export class ConsoleService {
    constructor() { }
    // log(pre: string, msg?: string): any {
    //   if (msg === undefined) {
    //     return function (msg: string) {
    //       console.log(`[${pre}] ${msg}`)
    //     }
    //   } else {
    //     console.log(`[${pre}] ${msg}`)
    //   }
    // }
    log(pre, ...optionalParams) {
        if (optionalParams === undefined || optionalParams.length === 0) {
            return function (...optionalParams) {
                if (pre !== undefined)
                    console.log(`[${pre}]`, ...optionalParams);
                else
                    console.log(...optionalParams);
            };
        }
        else {
            if (pre !== undefined)
                console.log(`[${pre}]`, ...optionalParams);
            else
                console.log(...optionalParams);
        }
    }
}
ConsoleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConsoleService_Factory() { return new ConsoleService(); }, token: ConsoleService, providedIn: "root" });
